import * as React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { GdprConsentRoute, PasswordResetRoute, ReportsRoute } from '~/Application/routes';
import { useStore } from '~/Application/Store';
import { ErrorConsumer } from '~/ErrorHandler';
import { Login } from '~/Password';
import { useBacklink } from '~/Router';
import { ErrorAlert } from '~/UI';
export var PasswordLogin = function () {
    var redirect = ReportsRoute.useRedirect();
    var redirectBack = useBacklink();
    var redirectToGdpr = GdprConsentRoute.useRedirect();
    var supportEmail = useStore().config.contact.supportEmail;
    return (<Grid data-testid='login-form' style={{ height: '100vh' }} textAlign='center' verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
				<Header>Přihlášení</Header>
				<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
				<Login contact={supportEmail} PasswordResetLink={PasswordResetRoute.Link} onComplete={function (accessTokenResponse) {
            if (!accessTokenResponse.gdprTermsConsent && accessTokenResponse.accessToken.impersonatedBy === null) {
                redirectToGdpr({});
            }
            else {
                redirectBack(function () {
                    redirect({});
                });
            }
        }}/>
			</Grid.Column>
		</Grid>);
};
PasswordLogin.displayName = 'Application.PasswordLogin';
